import { useLocation } from "react-router-dom";
import Percentage from "../../Home/Percentage";
import AboutHero from "../AboutHero";
import Advantage from "../Advantage";
import Approach from "../Approach";
import Director from "../Director";
import MissionVision from "../MissionVision";
import Principles from "../Principles";
import Team from "../Team";
import { useEffect } from "react";

const AboutNatio = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 200);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash]);

  return (
    <div className="overflow-hidden">
      <AboutHero id="about-natio" />
      <Percentage />
      <Director id="director" />
      <MissionVision id="mission-vision" />
      {/* <Team id="our-expert-team" /> */}
      <Principles id="core-principles" />
      <Advantage id="natio-advantages" />
      <Approach id="our-approach" />
    </div>
  );
};

export default AboutNatio;
